import api from "./axios";
import { apiPaths } from "./paths";
import type { Comment } from "@/types";

export const getComments = (articleId: string) =>
  api.get<Comment[]>(apiPaths.articles.comments(articleId)).then((r) => r.data);

export const createComment = (articleId: string, content: string) =>
  api
    .post<Comment>(apiPaths.articles.comments(articleId), { content })
    .then((r) => r.data);

export const updateComment = (articleId: string, id: string, content: string) =>
  api
    .put<Comment>(apiPaths.articles.comment(articleId, id), { content })
    .then((r) => r.data);

export const deleteComment = (articleId: string, id: string) =>
  api.delete(apiPaths.articles.comment(articleId, id));
